import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import memberMulGrade from './memberMulGrade';
import memberMove from './memberMove';
import memberMoney from './memberMoney';
import memberPwd from './memberPwd';
import { mapState, mapGetters, mapActions } from 'vuex';
import memberBank from './memberBank';
import memberBigV from './memberBigV';
import memberQuality from './memberQuality';
import { bankList, clientLogin, configGradeList, expectNumList, memberBatchRecharge, memberMulUpdateState, storeMulUpdate, takeSign, userAdd, userDel, userList } from '../../../../api/apis';
export default {
  name: 'memberManage',
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart,
    memberMulGrade: memberMulGrade,
    memberMove: memberMove,
    memberMoney: memberMoney,
    memberPwd: memberPwd,
    memberBank: memberBank,
    memberBigV: memberBigV,
    memberQuality: memberQuality
  },
  data: function data() {
    var _this = this;

    return {
      activeNames: 'search',
      gradeList: [],
      sum: {
        money1: 0,
        money2: 0,
        quantity: 0,
        quantity2: 0,
        quantity3: 0
      },
      searchModel_1000: {
        "del": false,
        "id": "id_1000",
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary",
          "id": "173"
        }, {
          "icon": "",
          "id": "227",
          "tag": "import",
          "title": "导入会员",
          "type": "success"
        }],
        "searchData": [{
          "children": [{
            "field": [{
              "desc": "会员编号",
              "key": "number",
              "value": ""
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "会员姓名",
              "key": "real_name"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "手机号码",
              "key": "phone"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "推荐上级",
              "key": "direct"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "进货上级",
              "key": "pdirect"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "身份证号",
              "key": "card_id"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "推荐顶点",
              "key": "top_number"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "进货顶点",
              "key": "top_pnumber"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "云仓数量",
              "key": "quantity"
            }],
            "operator": [{
              "key": "gte",
              "value": ">="
            }, {
              "key": "lte",
              "value": "<="
            }, {
              "key": "gt",
              "value": ">"
            }, {
              "key": "lt",
              "value": "<"
            }, {
              "key": "eq",
              "value": "="
            }],
            "placeholder": "请输入",
            "type": "input-mul-complex"
          }, {
            "field": [{
              "desc": "合约仓数量",
              "key": "quantity2"
            }],
            "operator": [{
              "key": "gte",
              "value": ">="
            }, {
              "key": "lte",
              "value": "<="
            }, {
              "key": "gt",
              "value": ">"
            }, {
              "key": "lt",
              "value": "<"
            }, {
              "key": "eq",
              "value": "="
            }],
            "placeholder": "请输入",
            "type": "input-mul-complex"
          }, {
            "field": [{
              "desc": "背负盒数",
              "key": "quantity3"
            }],
            "operator": [{
              "key": "gte",
              "value": ">="
            }, {
              "key": "lte",
              "value": "<="
            }, {
              "key": "gt",
              "value": ">"
            }, {
              "key": "lt",
              "value": "<"
            }, {
              "key": "eq",
              "value": "="
            }],
            "placeholder": "请输入",
            "type": "input-mul-complex"
          }],
          "id": 2,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "按条件",
          "type": 2,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [],
            "title": "自定义",
            "type": "custom-datetime-range"
          }],
          "id": 3,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "注册日期",
          "type": 1,
          "remoteFunc": ["modelConditionFunc_3"]
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "2"
            }],
            "title": "网体限制登录",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "3"
            }],
            "title": "单点限制登录",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "5"
            }],
            "title": "冻结",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "6"
            }],
            "title": "注销",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "0"
            }],
            "title": "未激活",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "4"
            }],
            "title": "退货",
            "total": 0,
            "type": "button"
          }],
          "id": 4,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "会员状态",
          "type": 0,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [],
            "multiple": false,
            "type": "select"
          }],
          "id": 5,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "会员等级",
          "type": 3,
          "remoteFunc": ["modelConditionFunc_5"]
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "big_v",
              "value": "0"
            }],
            "title": "否",
            "type": "button"
          }, {
            "field": [{
              "key": "big_v",
              "value": "1"
            }],
            "title": "是",
            "type": "button"
          }],
          "id": 15,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "是否大V",
          "type": 0,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "recharge_bank",
              "value": "0"
            }],
            "title": "无",
            "type": "button"
          }, {
            "field": [{
              "key": "recharge_bank",
              "value": "1"
            }],
            "title": "有",
            "type": "button"
          }],
          "id": 16,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "是否有汇款账户",
          "type": 0,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "store",
              "value": "0"
            }],
            "title": "否",
            "type": "button"
          }, {
            "field": [{
              "key": "store",
              "value": "1"
            }],
            "title": "是",
            "type": "button"
          }],
          "id": 17,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "是否店补",
          "type": 0,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [{
              "desc": "类型一",
              "key": "type",
              "value": "0"
            }, {
              "desc": "类型二",
              "key": "type",
              "value": "1"
            }],
            "multiple": false,
            "type": "select"
          }],
          "id": 18,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "推荐人等级",
          "type": 3,
          "remoteFunc": ["modelConditionFunc_18"]
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "is_recharge",
              "value": "1"
            }],
            "title": "是",
            "type": "button"
          }, {
            "field": [{
              "key": "is_rechage",
              "value": "0"
            }],
            "title": "否",
            "type": "button"
          }],
          "id": 20,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "服务中心",
          "type": 0,
          "remoteFunc": []
        }],
        "type": "searchTemplate"
      },
      tableModel_1001: {
        "border": true,
        "del": false,
        "headerButton": [{
          "id": "96",
          "tag": "default",
          "title": "批量定级",
          "type": "primary"
        }, {
          "icon": "",
          "id": "185",
          "tag": "default",
          "title": "批量店补",
          "type": null
        }, {
          "icon": "",
          "id": "188",
          "tag": "default",
          "title": "批量取消店补",
          "type": null
        }, {
          "id": "97",
          "tag": "default",
          "title": "会员注销",
          "type": "info"
        }, {
          "id": "98",
          "tag": "default",
          "title": "补扣款",
          "type": "primary"
        }, {
          "icon": "",
          "id": "204",
          "tag": "default",
          "title": "补扣仓存",
          "type": null
        }, {
          "id": "99",
          "tag": "default",
          "title": "网体限制登录",
          "type": "danger"
        }, {
          "id": "100",
          "tag": "default",
          "title": "单点限制登录",
          "type": "danger"
        }, {
          "id": "101",
          "tag": "default",
          "title": "冻结",
          "type": "danger"
        }, {
          "icon": "",
          "id": "207",
          "tag": "default",
          "title": "批量未激活",
          "type": null
        }, {
          "id": "102",
          "tag": "default",
          "title": "恢复状态",
          "type": "success"
        }, {
          "id": "103",
          "tag": "default",
          "title": "一键登录",
          "type": "success"
        }, {
          "id": "104",
          "tag": "default",
          "title": "密码修改",
          "type": null
        }, {
          "id": "107",
          "tag": "default",
          "title": "删除会员",
          "type": "danger"
        }, {
          "icon": "",
          "id": "127",
          "tag": "default",
          "title": "网体注销",
          "type": null
        }, {
          "icon": "",
          "id": "128",
          "tag": "default",
          "title": "网体冻结",
          "type": null
        }, {
          "icon": "",
          "id": "129",
          "tag": "default",
          "title": "网体恢复状态",
          "type": null
        }, {
          "icon": "",
          "id": "199",
          "tag": "default",
          "title": "批量签约",
          "type": null
        }, {
          "icon": "",
          "id": "200",
          "tag": "default",
          "title": "批量取消签约",
          "type": null
        }, {
          "icon": "",
          "id": "202",
          "tag": "default",
          "title": "设置汇款账户",
          "type": null
        }, {
          "icon": "",
          "id": "203",
          "tag": "default",
          "title": "批量大V",
          "type": null
        }, {
          "icon": "",
          "id": "105",
          "tag": "default",
          "title": "批量服务中心",
          "type": null
        }, {
          "icon": "",
          "id": "106",
          "tag": "default",
          "title": "撤销服务中心",
          "type": null
        }],
        "id": "id_1001",
        "isGroup": false,
        "isTree": false,
        "rowButton": [{
          "id": "108",
          "tag": "edit",
          "title": "信息修改",
          "type": "primary"
        }],
        "showPagination": true,
        "showSelection": true,
        "showSummary": true,
        "stripe": true,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableModel": [{
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "会员编号",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "90",
          "prop": "number"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "真实姓名",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "real_name"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "当前等级",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "grade"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "推荐人",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "90",
          "prop": "direct"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "推荐人姓名",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "ex_direct.real_name"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "推荐人等级",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "ex_direct.grade"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "进货上级",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "90",
          "prop": "pdirect"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "注册期数",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "expect_num"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "会员状态",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "status"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "移动电话",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "phone"
        }, {
          "add": 1,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "身份证号",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "card_id"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "定金居间费账户",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "money1"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "进货款居间费账户",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "money2"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "桃花果",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "money3"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "充值中心账户",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "money4"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "备注",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "mark"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "上次登录日期",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "last_time"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "创建日期",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "add_time"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "是否店补",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "store"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "云仓",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "quantity"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "合约仓",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "quantity2"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "背负盒数",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "quantity3"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "是否签约",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "is_sign"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "是否大V",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "big_v"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "汇款账户",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "recharge_bank"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "限制转账",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": null,
          "prop": "ex1"
        }],
        "tableName": "t_user",
        "tableRadioProps": {},
        "tableSelectProps": {
          "status": {
            "data": [{
              "key": 0,
              "value": "未激活"
            }, {
              "key": 1,
              "value": "已激活"
            }, {
              "key": 2,
              "value": "网体限制登录"
            }, {
              "key": 3,
              "value": "单点限制登录"
            }, {
              "key": 4,
              "value": "退货"
            }, {
              "key": 5,
              "value": "冻结"
            }, {
              "key": 6,
              "value": "注销"
            }],
            "id": 0,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "grade": {
            "data": [{
              "key": null,
              "value": ""
            }],
            "id": 1,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": true,
            "remoteFunc": "tableFunc_select_grade"
          },
          "level": {
            "data": [{
              "key": null,
              "value": ""
            }],
            "id": 12,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": true,
            "remoteFunc": "tableFunc_select_level"
          },
          "store": {
            "data": [{
              "key": 0,
              "value": "否"
            }, {
              "key": 1,
              "value": "是"
            }],
            "id": 14,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "is_sign": {
            "data": [{
              "key": 0,
              "value": "否"
            }, {
              "key": 1,
              "value": "是"
            }],
            "id": 15,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "key20": {
            "data": [{
              "key": null,
              "value": ""
            }],
            "id": 16,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "big_v": {
            "data": [{
              "key": 0,
              "value": "否"
            }, {
              "key": 1,
              "value": "是"
            }],
            "id": 17,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "recharge_bank": {
            "data": [{
              "key": null,
              "value": ""
            }],
            "id": 18,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": true,
            "remoteFunc": "tableFunc_select_recharge_bank"
          },
          "ex_direct.grade": {
            "data": [{
              "key": null,
              "value": ""
            }],
            "id": 19,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": true,
            "remoteFunc": "tableFunc_select_ex_directgrade"
          },
          "ex1": {
            "data": [{
              "key": 0,
              "value": "否"
            }, {
              "key": 1,
              "value": "是"
            }],
            "id": 20,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          }
        },
        "tableSwitchProps": {},
        "title": "会员",
        "type": "tableTemplate"
      },
      remoteFunc: {
        modelConditionFunc_3: function modelConditionFunc_3(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [];
          data = [[{
            key: "add_time",
            value: []
          }], // [{key:"add_time",value:_this.$g.fun.getDateRange(new Date(), 0, true)}],
          // [{key:"add_time",value:_this.$g.fun.getDateRange(new Date(), 1, true)}],
          // [{key:"add_time",value:_this.$g.fun.getDateRange(new Date(), 7, true)}],
          // [{key:"add_time",value:_this.$g.fun.getDateRange(new Date(), 30, true)}],
          // [{key:"add_time",value:_this.$g.fun.getDateRange(new Date(), 365, true)}],
          [{
            key: "add_time",
            value: []
          }]];
          resolve(tag, data);
        },
        modelConditionFunc_5: function modelConditionFunc_5(tag, relationData, resolve) {
          //筛选项模型数组
          configGradeList({}).then(function _callee(res) {
            var data, i, item;
            return regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    data = [];
                    data.push({
                      key: 'grade',
                      value: '',
                      desc: '全部'
                    });

                    for (i in res) {
                      item = res[i];
                      data.push({
                        key: 'grade',
                        value: item.tag,
                        desc: item.name
                      });
                    }

                    resolve(tag, [data]);

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
        },
        modelConditionFunc_18: function modelConditionFunc_18(tag, relationData, resolve) {
          //筛选条件数据
          configGradeList({}).then(function _callee2(res) {
            var data, i, item;
            return regeneratorRuntime.async(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    data = [];
                    data.push({
                      key: 'ex_direct.grade',
                      value: '',
                      desc: '全部'
                    });

                    for (i in res) {
                      item = res[i];
                      data.push({
                        key: 'grade',
                        value: item.tag,
                        desc: item.name
                      });
                    }

                    resolve(tag, [data]);

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            });
          });
        },
        tableFunc_select_grade: function tableFunc_select_grade(tag, relationData, resolve) {
          //筛选项模型数组
          configGradeList({}).then(function _callee3(res) {
            var data, i, item;
            return regeneratorRuntime.async(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    data = [];

                    for (i in res) {
                      item = res[i];
                      data.push({
                        key: item.tag,
                        value: item.name
                      });
                    }

                    _this.gradeList = data;
                    resolve(tag, data);

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            });
          });
        },
        tableFunc_select_recharge_bank: function tableFunc_select_recharge_bank(tag, relationData, resolve) {
          //筛选项模型数组
          var data = [];
          bankList({}).then(function _callee4(res) {
            var i;
            return regeneratorRuntime.async(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    for (i in res) {
                      data.push({
                        key: res[i].id,
                        value: res[i].bank_branch + ' ' + res[i].bank_code + ' ' + res[i].no
                      });
                    }

                    resolve(tag, data);

                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }
            });
          });
        },
        tableFunc_select_ex_directgrade: function tableFunc_select_ex_directgrade(tag, relationData, resolve) {
          //筛选项模型数组
          configGradeList({}).then(function _callee5(res) {
            var data, i, item;
            return regeneratorRuntime.async(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    data = [];

                    for (i in res) {
                      item = res[i];
                      data.push({
                        key: item.tag,
                        value: item.name
                      });
                    }

                    resolve(tag, data);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            });
          });
        }
      }
    };
  },
  computed: _objectSpread({}, mapState('d2admin/user', ['info'])),
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var _this2 = this;

      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
      }

      if (this.searchNumbers) {
        params.where = {
          number: {
            op: "in",
            value: this.searchNumbers
          }
        };
        this.searchNumbers = null;
      }

      this.$g.fun.startLoading();
      userList(params).then(function _callee6(res) {
        return regeneratorRuntime.async(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this2.sum = res.sum;
                resolve({
                  total: res.count,
                  data: res.rows
                });

                _this2.$g.fun.endLoading();

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {
      if (isEdit) {
        params.number = row.number;
      }

      userAdd(params).then(function _callee7(res) {
        return regeneratorRuntime.async(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                resolve();

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        });
      });
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      }); //xxxDel({id:ids}).then(async res=>{
      //  resolve()
      //})
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {//点击列表按钮回调
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {
      var _this3 = this;

      //点击列表头部按钮回调
      // console.log('row',btnIndex,row, this.tableModel_1001.headerButton[btnIndex])
      var buttonId = this.tableModel_1001.headerButton[btnIndex].id;

      if (row.length <= 0) {
        this.$message({
          message: '请至少选择一个会员',
          type: 'warning'
        });
        return;
      }

      var numbers = row.map(function (item) {
        return item.number;
      });

      if (buttonId == 96) {
        //批量定级
        this.$refs['mulGrade'].show(numbers, function () {
          _this3.table.reloadData();
        });
      } else if (buttonId == 98) {
        //补扣款
        this.$refs['memberMoney'].show(numbers[0], function () {
          _this3.table.reloadData();
        });
      } else if (buttonId == 103) {
        //一键登录
        clientLogin({
          number: numbers[0],
          tcode: this.info.code
        }).then(function _callee8(res) {
          var url;
          return regeneratorRuntime.async(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  url = res.url;
                  window.open(url, "_blank");

                case 2:
                case "end":
                  return _context8.stop();
              }
            }
          });
        });
      } else if (buttonId == 104) {
        //密码修改
        this.$refs['memberPwd'].show(row[0], function () {
          _this3.table.reloadData();
        });
      } else if (buttonId == 107) {
        this.confirm('会员删除,确定要执行批量操作么？', function () {
          _this3.$g.fun.startLoading();

          userDel({
            number: numbers
          }).then(function _callee9(res) {
            return regeneratorRuntime.async(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _this3.$g.fun.endLoading();

                    _this3.$message({
                      message: '批量删除成功',
                      type: 'success'
                    });

                    _this3.table.reloadData();

                  case 3:
                  case "end":
                    return _context9.stop();
                }
              }
            });
          });
        });
      } else if (buttonId == 185) {
        this.confirm('批量店补,确定要执行批量操作么？', function () {
          _this3.$g.fun.startLoading();

          storeMulUpdate({
            number: numbers,
            store: 1
          }).then(function _callee10(res) {
            return regeneratorRuntime.async(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _this3.$g.fun.endLoading();

                    _this3.$message({
                      message: '批量店补成功',
                      type: 'success'
                    });

                    _this3.table.reloadData();

                  case 3:
                  case "end":
                    return _context10.stop();
                }
              }
            });
          });
        });
      } else if (buttonId == 188) {
        this.confirm('批量取消店补,确定要执行批量操作么？', function () {
          _this3.$g.fun.startLoading();

          storeMulUpdate({
            number: numbers,
            store: 0
          }).then(function _callee11(res) {
            return regeneratorRuntime.async(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _this3.$g.fun.endLoading();

                    _this3.$message({
                      message: '批量取消店补成功',
                      type: 'success'
                    });

                    _this3.table.reloadData();

                  case 3:
                  case "end":
                    return _context11.stop();
                }
              }
            });
          });
        });
      } else if (buttonId == 199 || buttonId == 200) {
        this.$g.fun.startLoading();
        takeSign({
          id: numbers,
          is_sign: buttonId == 199 ? 1 : -1
        }).then(function _callee12(res) {
          return regeneratorRuntime.async(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  _this3.$g.fun.endLoading();

                  _this3.$message({
                    message: '操作成功',
                    type: 'success'
                  });

                  _this3.table.reloadData();

                case 3:
                case "end":
                  return _context12.stop();
              }
            }
          });
        });
      } else if (buttonId == 202) {
        this.$refs['memberBank'].show(numbers[0], function () {
          _this3.table.reloadData();
        });
      } else if (buttonId == 203) {
        this.$refs['memberBigV'].show(numbers, function () {
          _this3.table.reloadData();
        });
      } else if (buttonId == 204) {
        this.$refs['memberQuality'].show(numbers[0], function () {
          _this3.table.reloadData();
        });
      } else if (buttonId == 105 || buttonId == 106) {
        //充值中心
        var msg = '';
        var value = 0;

        if (buttonId == 105) {
          msg = '批量设置为充值中心';
          value = 1;
        } else {
          msg = '批量撤销充值中心';
          value = 0;
        }

        console.log("cccc", value);
        this.confirm(msg + ',确定要执行批量操作么？', function () {
          memberBatchRecharge({
            number: numbers,
            is_recharge: value
          }).then(function _callee13(res) {
            return regeneratorRuntime.async(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _this3.$message({
                      message: '批量设置成功',
                      type: 'success'
                    });

                    _this3.table.reloadData();

                  case 2:
                  case "end":
                    return _context13.stop();
                }
              }
            });
          });
        });
      } else {
        var status = 0;
        var _msg = '';

        if (buttonId == 97) {
          status = 6; //注销

          _msg = '选中会员注销';
        } else if (buttonId == 99) {
          status = 3; //顶点位限制登录

          _msg = '选中会员以及其子点位会员全部限制登录';
        } else if (buttonId == 100) {
          status = 2; //单点位限制登录

          _msg = '选中会员全部限制登录';
        } else if (buttonId == 101) {
          status = 5; //冻结

          _msg = '选中会员账号被冻结，不参与定级结算';
        } else if (buttonId == 102) {
          status = 1;
          _msg = '选中会员账号恢复正常状态';
        } else if (buttonId == 127) {
          status = 7;
          _msg = '选中会员以及其子点位会员全部注销状态';
        } else if (buttonId == 128) {
          status = 8;
          _msg = '选中会员以及其子点位会员全部冻结状态';
        } else if (buttonId == 129) {
          status = 9;
          _msg = '选中会员以及其子点位会员全部恢复状态';
        } else if (buttonId == 205) {
          status = 0;
          _msg = '选中会员全部未激活状态';
        }

        this.confirm(_msg + '，确定要执行批量操作么？', function () {
          _this3.$g.fun.startLoading();

          memberMulUpdateState({
            number: numbers,
            status: status
          }).then(function _callee14(res) {
            return regeneratorRuntime.async(function _callee14$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                    _this3.$g.fun.endLoading();

                    _this3.$message({
                      message: '批量设置成功',
                      type: 'success'
                    });

                    _this3.table.reloadData();

                  case 3:
                  case "end":
                    return _context14.stop();
                }
              }
            });
          });
        });
      }
    },
    onSummary: function onSummary(param) {
      var _this4 = this;

      //列表尾部合计回调
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }

        if (column.property === 'money1') {
          sums[index] = _this4.sum.money1;
        } else if (column.property === 'money2') {
          sums[index] = _this4.sum.money2;
        } else if (column.property === 'quantity') {
          sums[index] = _this4.sum.quantity;
        } else if (column.property === 'quantity2') {
          sums[index] = _this4.sum.quantity2;
        } else if (column.property === 'quantity3') {
          sums[index] = _this4.sum.quantity3;
        }
      });
      return sums;
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;

        if (results.length === 0) {
          return;
        }

        if (!results[0].hasOwnProperty('会员编号')) {
          this.$alert('请添加"会员编号"列', '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });
          return;
        }

        var tmp = [];

        for (var i in results) {
          tmp.push(results[i]['会员编号']);
        }

        this.searchNumbers = tmp;
        this.table.reloadData();
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    confirm: function confirm(msg, handle) {
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (handle) {
          handle();
        }
      }).catch(function () {});
    }
  }
};